module.exports = __webpack_public_path__ + "static/profile-pic-a8412ea4b2687ebdd528aa96ae95bc1d.jpg";